import React from 'react';
import { Modal } from '../../../../../components/ui/Modal';
import { ToneBadge } from '../../../../../components/ui/ToneBadge';
import { getStatusLabel, getSubstatusLabel } from '../../../../../features/webhooks/webhooksUtils';
import {
  getDispatchStateLabel,
  getDispatchStateTone,
} from '../../../../../features/webhookHistory/webhookHistoryConstants';

const Block = ({ title, value }) => (
  <div className="space-y-1">
    <span className="text-xs font-semibold text-text-muted uppercase tracking-wider">{title}</span>
    <pre className="bg-ninja-gray dark:bg-[#0f0f0f] border border-border rounded-xl p-3 text-xs overflow-x-auto max-h-64 whitespace-pre-wrap break-all">
      {value && Object.keys(value).length > 0 ? JSON.stringify(value, null, 2) : '—'}
    </pre>
  </div>
);

/**
 * What was sent for one dispatch: the URL, the headers and the body as they
 * went out, with the placeholders already resolved. Read-only.
 *
 * @param {object} props
 * @param {object|null} props.webhook - A row of the history, or null when closed.
 * @param {() => void} props.onClose
 */
export const WebhookPayloadModal = ({ webhook, onClose }) => (
  <Modal
    isOpen={Boolean(webhook)}
    onClose={onClose}
    title={webhook ? `Webhook #${webhook.id}` : ''}
    size="lg"
    testId="webhook-payload-modal"
  >
    {webhook && (
      <div className="space-y-5">
        <div className="flex flex-wrap items-center gap-3 text-sm">
          <ToneBadge tone={getDispatchStateTone(webhook.dispatch_state)}>
            {getDispatchStateLabel(webhook.dispatch_state)}
          </ToneBadge>
          <span className="font-semibold text-ninja-dark dark:text-white">
            {getStatusLabel(webhook.status)}
            {webhook.substatus && webhook.substatus !== 'not_specified'
              ? ` / ${getSubstatusLabel(webhook.status, webhook.substatus)}`
              : ''}
          </span>
          <span className="text-text-muted">
            {webhook.created_at ? new Date(webhook.created_at).toLocaleString('es-CL') : ''}
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <div>
            <span className="text-xs font-semibold text-text-muted uppercase tracking-wider">Operador</span>
            <p className="text-ninja-dark dark:text-white">{webhook.admin?.email || '—'}</p>
          </div>
          <div>
            <span className="text-xs font-semibold text-text-muted uppercase tracking-wider">Seller</span>
            <p className="text-ninja-dark dark:text-white">{webhook.seller?.social_reason || '—'}</p>
          </div>
          <div>
            <span className="text-xs font-semibold text-text-muted uppercase tracking-wider">Orden</span>
            <p className="text-ninja-dark dark:text-white">
              {webhook.order ? `#${webhook.order.id}` : '—'}
              {webhook.order?.reference_id ? ` · ${webhook.order.reference_id}` : ''}
            </p>
          </div>
          <div>
            <span className="text-xs font-semibold text-text-muted uppercase tracking-wider">Envío</span>
            <p className="text-ninja-dark dark:text-white">#{webhook.delivery_id}</p>
          </div>
        </div>

        <div className="space-y-1">
          <span className="text-xs font-semibold text-text-muted uppercase tracking-wider">URL destino</span>
          <p className="text-sm break-all text-ninja-dark dark:text-white">{webhook.url}</p>
        </div>

        <Block title="Headers" value={webhook.headers} />
        <Block title="Body" value={webhook.body} />
      </div>
    )}
  </Modal>
);
